module.exports = __webpack_public_path__ + "static/media/yaw_misalign_comparative.5ced04ee.svg";